import { Link } from "react-router-dom";
import { CONTACT } from "../../data/site";

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/5 pt-20 pb-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <div className="font-serif-display text-4xl md:text-6xl text-[#F5F5F0] leading-none">
              Cresta <span className="italic text-champagne">Bath & Tile</span>
            </div>
            <p className="mt-6 text-[#A3A3A3] max-w-md font-sans-body leading-relaxed">
              Premium bathroom renovations and custom tiling for homeowners across the Greater Ottawa Area.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="overline">Contact</div>
            <ul className="mt-5 space-y-3 text-[#F5F5F0]/90 font-sans-body text-sm">
              <li><a href={CONTACT.phoneHref} className="hover:text-champagne underline-grow">{CONTACT.phone}</a></li>
              <li><a href={CONTACT.emailHref} className="hover:text-champagne underline-grow">{CONTACT.email}</a></li>
              <li className="text-[#A3A3A3]">{CONTACT.area}</li>
              <li className="text-[#A3A3A3]">{CONTACT.hours}</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="overline">Navigate</div>
            <ul className="mt-5 space-y-3 text-[#A3A3A3] font-sans-body text-sm">
              <li><a href="#services" className="hover:text-champagne underline-grow">Services</a></li>
              <li><a href="#process" className="hover:text-champagne underline-grow">Process</a></li>
              <li><a href="#portfolio" className="hover:text-champagne underline-grow">Portfolio</a></li>
              <li><a href="#estimate" className="hover:text-champagne underline-grow">Free Estimate</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row gap-4 justify-between text-[11px] tracking-[0.2em] uppercase text-[#525252] font-sans-body">
          <span className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>© {new Date().getFullYear()} Cresta Bath & Tile. All rights reserved.</span>
            <span className="text-[#262626]">·</span>
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="hover:text-champagne transition-colors"
            >
              Privacy Policy
            </Link>
          </span>
          <span>Licensed · Insured · Ottawa, Ontario</span>
        </div>
      </div>
    </footer>
  );
}
